import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ApplicationDataService } from '../../../services/application.service';
import { Property } from '../../models/property';
import { EventEmitterService } from 'services/event-emitter.service';
import { SplashService } from 'services/splash.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ImportFromBankDialogComponent } from './import-from-bank-dialog/import-from-bank-dialog.component';
import { UploadDocumentTracking } from 'app/models/upload-document-tracking';
import { ApplicationInterface } from 'app/interface/application';
import { AnalyticsService } from 'services/analytics.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent implements OnInit, AfterViewInit {
  @ViewChild('documents') private myScrollContainer: ElementRef;
  modelProperty: Property;
  splashHTML: string;
  showUploadForm: boolean;
  showUploadOptions: boolean;
  application?: ApplicationInterface
  hasRentableItems: boolean;
  totalApplicationSteps: number = 8;
  currentApplicationStep: number = 5;
  verifastEnabled: boolean;

  constructor(
    private applicationService: ApplicationDataService,
    private eventEmitterService: EventEmitterService,
    private splashService: SplashService,
    public dialog: MatDialog,
    private readonly analyticsService: AnalyticsService) {
      this.analyticsService.track(
        'HRA Application',
        'Documents',
        'Start',
        'Start',
        '',
        this.additionalAnalyticsDetails());
    const mfUnitCode = localStorage.getItem('mfunitcode');
    const yardiKey = localStorage.getItem('YardiKey');

    this.applicationService.renderDocumentTracking(yardiKey, +localStorage.getItem('RentalApplicationKey')).subscribe(res => this.setUploadOptions(res), err => err);
    this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateSplashHTML(res));
    this.splashService.updateSplash("apply");

    if (mfUnitCode != null) {
      this.applicationService.getMFProperty(yardiKey, mfUnitCode)
        .subscribe(res => this.setProperty(res.results));
    } else {
      this.applicationService.getProperty(yardiKey)
        .subscribe(res => this.setProperty(res.results));
    }
  }

  private additionalAnalyticsDetails(): any {
    try {
      return {
        'Property': this.modelProperty ?? {}
      };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  ngOnInit() {
    const rentableItems = localStorage.getItem('hasRentableItems');
    const verifastEnabled = localStorage.getItem('verifastEnabled');
    const hasAncillaryItems = localStorage.getItem('HasAncillaryItems');
    if ((rentableItems && rentableItems === 'true') || (hasAncillaryItems && hasAncillaryItems === 'true')) {
      this.hasRentableItems = true;
      this.totalApplicationSteps = 9;
    }

    if (verifastEnabled && verifastEnabled === 'true') {
      this.verifastEnabled = true;
      this.currentApplicationStep++;
      this.totalApplicationSteps++;
    }

    const property = JSON.parse(localStorage.getItem('SelectedProperty'));
    if (property != null) {
      this.modelProperty = property[0];
      if ((property[0].min_rent != null && property[0].max_rent != null) && (property[0].min_rent == property[0].max_rent)) {
        this.modelProperty.rent = property[0].min_rent.toLocaleString();
      }
      else if (property[0].min_rent != null && property[0].max_rent != null) {
        this.modelProperty.rent = property[0].min_rent.toLocaleString() + '-$' + property[0].max_rent.toLocaleString()
      }
    }
  }

  setUploadOptions(res: boolean) {
    if (res) {
      this.showUploadOptions = res;
    }
    else {
      this.showUploadForm = true;
    }
  }

  updateSplashHTML(res: string) {
    this.splashHTML = res;
  }

  setProperty(property: Property[]) {
    this.modelProperty = property[0];

    if ((property[0].min_rent != null && property[0].max_rent != null) && (property[0].min_rent == property[0].max_rent)) {
      this.modelProperty.rent = property[0].min_rent.toLocaleString();
    }
    else if (property[0].min_rent != null && property[0].max_rent != null) {
      this.modelProperty.rent = property[0].min_rent.toLocaleString() + '-$' + property[0].max_rent.toLocaleString()
    }
      
    this.applicationService.getApplicantApplicationForProperty(this.modelProperty.unit_code)
    .subscribe(res => {
      this.application = res;
      if (this.application.RentalAppStatus.toUpperCase() != 'DRAFT' && this.application.RentalAppStatus.toUpperCase() != 'WAIT LIST') {
        this.modelProperty.rent = `${this.application?.RentAmount}`;
      }
    }, err => this.applicationService.handleError(err));
  }

  ngAfterViewInit(): void {
    try {
      this.myScrollContainer.nativeElement.scrollIntoView(false);
    } catch (err) { console.log('error: ' + err); }
  }

  showUploadFormClick() {
    this.showUploadForm = true;
    this.trackingInfoClicked("UploadDocuments");
  }

  importFromBankClick() {
    this.trackingInfoClicked("ImportFromBank");
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "300px";

    let dialogRef = this.dialog.open(ImportFromBankDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.showUploadForm = true;
    });
  }

  trackingInfoClicked(option: string) {
    this.applicationService.uploadDocumentTracking(new UploadDocumentTracking(+localStorage.getItem('RentalApplicationKey'), option)).subscribe(res => res, err => err);
  }

}
